<template>
  <div id="ModelRecordHistory">
    <a-modal
      title="录音查询"
      width="720px"
      :visible="this.$store.state.isShowRecordHistoryModel"
      @cancel="closeModel"
    >
      <template slot="footer">
        <a-button key="back" @click="closeModel">关闭</a-button>
      </template>
      <table>
        <tr>
          <td style="width:150px">学生ID 或 手机号：</td>
          <td>
            <a-input
              type="text"
              style="width:250px;margin-right:20px"
              id="searchtext"
              v-model="searchtext"
            ></a-input>
            <a-button
              key="submit"
              type="primary"
              @click="search"
              id="searchBtn"
            >
              查询
            </a-button>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <a-divider />
          </td>
        </tr>
      </table>

      <a-table
        :columns="callHistoryColumns"
        :rowKey="record => record.callId"
        :dataSource="tableCallHistoryData"
        size="small"
        :pageSize="2"
      >
        <div slot="qkidsID" slot-scope="text">
          {{ text }}
        </div>
        <div slot="starttimecaller" slot-scope="text">
          {{ text | timeFilter }}
        </div>
        <div slot="duration" slot-scope="text">
          {{ text | stom }}
        </div>
        <div slot="recordUrl" slot-scope="text, record">
          <template v-if="isShowRecordUrl(record.recordUrl)">
            <a
              v-on:click="playAudioURL(record.callId)"
              :id="setAudioBtnID(record.callId)"
              >播放</a
            >
            |
            <audio :src="record.recordUrl" :id="record.callId">
              您的浏览器不支持audio
            </audio>
            <a :href="record.recordUrl">下载</a>
          </template>
          <template v-else>
            -
          </template>
        </div>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { GetRecordHistoryWithPhoneOrID } from '@/api/QkidsApi.js'
import Message from 'ant-design-vue/lib/message'

const callHistoryColumns = [
  { title: '学生ID', dataIndex: 'qkidsID', key: 'qkidsID', scopedSlots: { customRender: 'qkidsID' } },
  { title: '顾问名称', dataIndex: 'username', key: 'username', scopedSlots: { customRender: 'username' } },
  { title: '发起时间', dataIndex: 'starttimecaller', key: 'starttimecaller', scopedSlots: { customRender: 'starttimecaller' } },
  { title: '通话时长', dataIndex: 'duration', key: 'duration', scopedSlots: { customRender: 'duration' } },
  { title: '录音管理', dataIndex: 'recordUrl', key: 'recordUrl', scopedSlots: { customRender: 'recordUrl' } }
]

export default {
  name: 'ModelCallSetting',
  data: function () {
    return {
      searchtext: '',
      callHistoryColumns,
      tableCallHistoryData: []
    }
  },
  methods: {
    closeModel (e) {
      this.$store.state.isShowRecordHistoryModel = false
    },
    isShowRecordUrl: (url) => {
      if (url === '') {
        return false
      } else {
        return true
      }
    },
    playAudioURL: function (str) {
      var audio = document.getElementById(str)
      var btn = document.getElementById('btnr' + str)
      if (audio.paused) {
        audio.play()
        btn.innerHTML = '暂停'
      } else {
        audio.pause()
        btn.innerHTML = '继续播放'
      }
      btn.addEventListener('ended', function () {
        btn.innerHTML = '重新播放'
      })
    },
    setAudioBtnID: function (str) {
      return 'btnr' + str
    },
    search () {
      if (/^\d+$/.test(this.searchtext)) {
        var searchTextLength = this.searchtext.length
        console.log('search' + searchTextLength)
        var type = 'ID'
        if (searchTextLength === 11) {
          type = 'phone'
        }
        GetRecordHistoryWithPhoneOrID(type, this.searchtext)
          .then(res => {
            console.log(res)
            this.tableCallHistoryData = res.data
          }).catch(err => {
            console.log(err)
          })
      } else {
        Message.error('只能输入纯数字')
      }
    }
  },
  watch: {

  },
  created: function () {

  },
  filters: {
    timeFilter: (val) => {
      val = val.replace('T', ' ')
      val = val.replace('+08:00', '')
      return val
    },
    hidePhone: (phone) => {
      return phone.toString().substr(0, 3) + '****' + phone.toString().substr(7, 11)
    },
    stom: (value) => {
      var secondTime = parseInt(value)
      var minuteTime = 0
      if (secondTime > 60) {
        minuteTime = parseInt(secondTime / 60)
        secondTime = parseInt(secondTime % 60)
      }
      var result = '' + parseInt(secondTime) + '秒'
      if (minuteTime > 0) {
        result = '' + parseInt(minuteTime) + '分' + result
      }
      return result
    }
  }
}
</script>

<style scoped>
</style>
